// https://material.io/resources/icons/?icon=assignment&style=baseline
import {} from "./menuopt";

let Menu = [
  {
    header: localStorage.active_user
      ? JSON.parse(localStorage.active_user).company_name ||
        JSON.parse(localStorage.active_user).company.name ||
        ""
      : ""
  },
  {
    title: "Category",
    group: "category",
    tag: "category",
    component: "category",
    icon: "category",
    items: [
      {
        title: "Student",
        icon: "location_city",
        name: "Student",
        tag: "student",
        component: "Students"
      },
      {
        title: "Staff",
        icon: "location_city",
        name: "Staff",
        tag: "staff",
        component: "Staff"
      },
      {
        title: "Visitor",
        icon: "location_city",
        name: "Visitor",
        tag: "visitor",
        component: "Visitors"
      },
      {
        title: "Contractor",
        icon: "location_city",
        name: "Contractors",
        tag: "contractor",
        component: "Contractors"
      }
    ]
  },
  { divider: true },
  {
    title: "Logs",
    tag: "track",
    group: "logs",
    icon: "access_time",
    items: [
      {
        title: "Sign In",
        tag: "track",
        icon: "check",
        name: "Signed in",
        component: "Signed in"
      },
      {
        title: "Sign Out",
        tag: "track",
        icon: "subdirectory_arrow_left",
        name: "Signed out",
        component: "Signed out"
      },
      {
        title: "Emergency",
        icon: "subdirectory_arrow_left",
        name: "Emergency",
        tag: "emergency",
        component: "Emergency"
      }
    ]
  },
  { divider: true },
  {
    title: "Historical",
    group: "historical_list",
    component: "Historical List",
    icon: "history",
    tag: "historical",
    items: [
      {
        title: "Student",
        icon: "group",
        tag: "student",
        name: "Historical Students",
        component: "Historical Students"
      },
      {
        title: "Staff",
        group: "apps",
        tag: "staff",
        name: "Historical Staff",
        component: "Historical Staff"
      },
      {
        title: "Visitor",
        group: "apps",
        tag: "visitor",
        name: "Historical Visitors",
        component: "Historical Visitors"
      },
      {
        title: "Contractor",
        group: "apps",
        tag: "contractor",
        name: "Historical Contractors",
        component: "Historical Contractors"
      }
    ]
  },
  { divider: true },
  {
    title: "Class Types",
    group: "apps",
    icon: "school",
    tag: "student",
    name: "Class Types"
  },
  { divider: true },
  {
    title: "Quick Code",
    group: "apps",
    tag: "quick_code",
    icon: "call_missed_outgoing",
    name: "Quickpins List"
  },
  { divider: true },
  {
    title: "Authorizations",
    group: "historical_list",
    tag: "authorization",
    icon: "security",
    items: [
      {
        title: "WWCC",
        tag: "wwcc",
        component: "Wwcc List",
        icon: "radio_button_unchecked",
        name: "Wwcc List"
      }
    ]
  },
  { divider: true },
  {
    title: "Policy",
    icon: "event_note",
    tag: "policy",
    name: "Policies"
  },
  { divider: true },
  {
    title: "Reports",
    group: "historical_list",
    component: "Historical List",
    icon: "assignment",
    tag: "report",
    items: [
      {
        title: "Visitor",
        icon: "person",
        tag: "visitor",
        name: "ReportVisitor",
        component: "ReportVisitor"
      },
      {
        title: "Contractor",
        icon: "person",
        tag: "contractor",
        name: "ReportContractor",
        component: "ReportContractor"
      },
      {
        title: "Staff",
        icon: "person",
        tag: "staff",
        name: "ReportStaff",
        component: "ReportStaff"
      },
      {
        title: "Student",
        icon: "person",
        tag: "student",
        name: "ReportStudent",
        component: "ReportStudent"
      }
    ]
  },
  // { divider: true },
  // {
  //   title: "Bulk Import",
  //   group: "apps",
  //   icon: "unarchive",
  //   name: "Bulk Import"
  // },
  { divider: true },
  {
    title: "Group Logs",
    icon: "group",
    tag: "group",
    name: "GroupLogs"
  },
  { divider: true },
  {
    title: "Bulk Process",
    icon: "unarchive",
    tag: "bulk_process",
    name: "Bulk Process"
  },
  { divider: true },
  {
    title: "Resources",
    icon: "devices_other",
    tag: "resource",
    name: "Manage Resources"
  },
  { divider: true },
  {
    title: "Support",
    icon: "support",
    tag: "support",
    name: "Support"
  }
  // { divider: true },
  // {
  //   title: "Check-In Issues",
  //   icon: "error",
  //   tag: "errorlog",
  //   name: "ErrorLog"
  // }
];

let modules = ["visitor", "contractor", "quick_code"];
// const modules = ["student", "policy", "staff", "quick_code", "group", "bulk"];

if (localStorage.active_user) {
  let object = JSON.parse(localStorage.active_user);
  modules =
    object.permissions || object.modules || object.company.modules || [];
}

Menu = Menu.filter(ob => {
  if (ob.items) {
    ob.items = ob.items.filter(obj => {
      return modules.includes(obj.tag);
    });
  }
  if (ob.tag) {
    return modules.includes(ob.tag);
  } else {
    return ob;
  }
});

// Menu.forEach(item => {
//   if (item.items) {
//     item.items.sort((x, y) => {
//       let textA = x.title.toUpperCase();
//       let textB = y.title.toUpperCase();
//       return textA < textB ? -1 : textA > textB ? 1 : 0;
//     });
//   }
// });

// response[0].image = "https://homepages.cae.wisc.edu/~ece533/images/airplane.png";

export default Menu;
